// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner-vG3Zb","new":"new-10hst"};